import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import {
  GoogleAuthProvider,
  getAuth,
  inMemoryPersistence,
  setPersistence,
} from "firebase/auth";

import firebaseConfig from "@/firebaseConfig";

const app = initializeApp(firebaseConfig);
getAnalytics(app);
const auth = getAuth(app);
// As httpOnly cookies are to be used, do not persist any state client side.
setPersistence(auth, inMemoryPersistence);
const provider = new GoogleAuthProvider();

export { auth, provider };
